import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const SettingsRedirect = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Redirect based on user role
      if (user.role === 'investor') {
        navigate('/settings/investor');
      } else if (user.role === 'project_holder') {
        navigate('/settings/project-holder');
      } else if (user.role === 'admin') {
        navigate('/admin'); // Admins have their own dashboard
      } else {
        // Default to home if user role is unknown
        navigate('/');
      }
    } else {
      // If not logged in, redirect to login
      navigate('/login');
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Redirecting to settings...</p>
      </div>
    </div>
  );
};

export default SettingsRedirect;